import React from 'react';

const CloseIcon = () => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      viewBox="0 0 1000 1000"
      enableBackground="new 0 0 1000 1000"
      xmlSpace="preserve"
    >
      <g>
        <path d="M990,798.6c0,22-7.7,40.7-23.1,56.1L854.7,966.9c-15.4,15.4-34.1,23.1-56.1,23.1c-22,0-40.7-7.7-56.1-23.1L500,724.4L257.5,966.9c-15.4,15.4-34.1,23.1-56.1,23.1c-22,0-40.7-7.7-56.1-23.1L33.1,854.7C17.7,839.3,10,820.6,10,798.6c0-22,7.7-40.7,23.1-56.1L275.6,500L33.1,257.5C17.7,242.1,10,223.4,10,201.4s7.7-40.7,23.1-56.1L145.3,33.1C160.7,17.7,179.4,10,201.4,10c22,0,40.7,7.7,56.1,23.1L500,275.6L742.5,33.1C757.9,17.7,776.6,10,798.6,10c22,0,40.7,7.7,56.1,23.1l112.2,112.2c15.4,15.4,23.1,34.1,23.1,56.1s-7.7,40.7-23.1,56.1L724.4,500l242.5,242.5C982.3,757.9,990,776.6,990,798.6L990,798.6z" />
      </g>
    </svg>
  );
};

export default CloseIcon;
